import React from 'react';
import Grid2 from '@mui/material/Unstable_Grid2/Grid2';
import { Select } from "antd";
import { ErrorMessage, } from "../../../global/components/ValidationIcon";

export const DropDown = ({ label, name, error, errors, placeholder, value, onChangeFn, options, customClass }) => {
    return <Grid2 item xs={12} sm={12} md={12} lg={12} className={'no-padding-dropdown-location'}>
        <div className="mb-3">
            <label htmlFor={name} className={`input-label-user ${customClass ? customClass : ""}`}> {label} </label>
            <div className="input-container">
                <Select
                    className={`selectboxstyle shipment-clone-fields ${error == ""? "" :error?"shipment-form-field-error" : "shipment-form-fields shipment-form-field-success"}`}
                    key={"state"}
                    name={name}
                    placeholder={placeholder}
                    value={value}
                    onChange={(value) => { onChangeFn(value); }}
                    options={options || []}
                />
            </div>
            <div style={{ paddingTop: 5 }}>
                <ErrorMessage className="ats-error-message-imp" fieldName={name} errors={errors} />
            </div>
        </div>
    </Grid2>
}